<template>
    <section ref="section5" class="mx-auto flex h-full flex-col">
        <v-register-head
            @previous="4"
            :step="5"
            :landing-route="registrationProcessData.routes.landing"
        ></v-register-head>
        <div
            class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
        >
            <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                <figure class="flex gap-3">
                    <div>
                        <v-icon icon="envelope-checked" size="8"></v-icon>
                    </div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Elektronski naslov potrjen!
                        </div>
                        <div class="text-body-regular text-black-40">
                            Nadaljujte z kreacijo računa
                        </div>
                    </div>
                </figure>
            </figure>
        </div>
        <div
            class="flex h-full max-h-[102px] justify-between border-t px-4 pt-4"
        >
            <div class="flex w-full justify-center">
                <a
                    :href="registrationProcessData.routes.setupPassword"
                    class="button button--form"
                >
                    <label class="text-small-text-medium">Nadaljujte</label>
                    <v-icon icon="arrow-right" size="4"></v-icon>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        registrationProcessData: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
};
</script>
